import React, { Component } from 'react';
import autobind from 'react-autobind';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '@citrus/tabs';
import PctyQuestionBuilder from '@pcty/react-question-builder';
import isEqual from 'lodash.isequal';
import PctySurvey from '@pcty/react-survey';
import { replaceAt } from '@pcty/utils-array';
import { BUILDER_TYPE } from '@pcty/react-question-builder/lib/PctyQuestionBuilder.Constants';
import * as JsonConverter from '../../Services/surveyJsConverters';
import { isNullOrEmptyString } from '../../../Common/Services/utilities';

import './citrusFormEditor.less'
import { isNullOrEmpty } from '@pcty/utils';


class CitrusFormEditor extends Component {

  constructor(props) {
    super(props);
    autobind(this);

    const surveySettings = {
      duration: 2,
      questionsInOrder: true,
      oneQuestionAtATime: false,
      displayQuestionsInPages: true,
      backwardMovement: true,
      hideHeader: true,
      hideFooter: false,
      hideComplete: true,
      useInlineActions: false,
      displayPageNumbers: false,
      allowDecline: false,
      allowCancel: false,
      allowSaveDraft: false,
    };

    const responses = [];

    let formTypeOptions = [];
    if (props.showCategories && props.formCategories) {
      // only load the formTypeOptions if we need to!
      formTypeOptions = props.formCategories.map(item => { return { text: item.label, value: item.id, selected: props.selectedFormCategoryId === item.id}})
    }

    let questions = [];
    if (props.configuration) {
      questions = JsonConverter.convertSurveyjsToCitrusJsonConfiguration(props.configuration);
    }

    this.state = {
      questions,
      surveySettings: surveySettings,
      responses,
      formTypeOptions,
      activeTab: 0,
      name: {
        value: props.formName,
        validationState: {
          valid: !isNullOrEmptyString(props.formName),
          errorMessage: 'Name is required',
          showValidationState: true,
        },
      },
      categoryType: {
        selected: {
          value: '',
          text: ''
        },
        validationState: {
          valid: !isNullOrEmptyString(props.selectedFormCategoryId),
          errorMessage: 'Category is required',
          showValidationState: true,
        },
      },
    };

    this.qbConfigOptions = {
      questionsPerPage: 0,
      enablePageManager: true,
      enableConditionalQuestions: true,
      enableInlineEditing: true,
      setDefaultRequired: false,
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.formName, nextProps.formName)) {
      let name = {...this.state.name};
      name.value = nextProps.formName;
      name.validationState.valid = !isNullOrEmptyString(nextProps.formName),

      this.setState({name});
    }

    if (!isEqual(this.props.selectedFormCategoryId, nextProps.selectedFormCategoryId)) {
      let categoryType = {...this.state.categoryType};

      if (nextProps.selectedFormCategoryId && this.props.formCategories) {
        const selected = this.props.formCategories.filter(item => item.id === nextProps.selectedFormCategoryId);
        categoryType.selected = selected && selected.length > 0 ? { text: selected[0].label, value: selected[0].id} : {value: '', text: ''};
      }

      let formTypeOptions = [];
      if (this.props.showCategories && this.props.formCategories) {
        // only load the formTypeOptions if we need to!
        formTypeOptions = this.props.formCategories.map(item => { return { text: item.label, value: item.id, selected: (item.id === nextProps.selectedFormCategoryId)}})
      }

      categoryType.validationState.valid = !isNullOrEmptyString(categoryType.selected.value);
      this.setState({categoryType, formTypeOptions});
    }

    // handle the case for a new config
    if (!isEqual(this.props.configuration, nextProps.configuration) || isNullOrEmpty(nextProps.configuration)) {
      let configuration = nextProps.configuration || "";
      let questions = [];
      let formTypeOptions = [];
      if (this.props.showCategories && this.props.formCategories) {
        // only load the formTypeOptions if we need to!
        formTypeOptions = this.props.formCategories.map(item => { return { text: item.label, value: item.id, selected: (item.id === nextProps.selectedFormCategoryId)}})
      }
      if (configuration.length === 0) {
        this.setState({questions, formTypeOptions});
      }
    }
  }

  onChangeTab(index) {
    this.setState({ activeTab: index, responses: [] });
  };

  onChangeName(name, questions) {
    let updatedName = {
      ...name,
      validationState: {
        valid: !isNullOrEmptyString(name.value),
        errorMessage: 'Name is required',
        showValidationState: isNullOrEmptyString(name.value),
      },
    };

    this.setState({ name: updatedName });
    this.props.onNameChange(name.value)
  };

  onChangeCategoryType(categoryType) {
    this.setState({ categoryType });
    this.props.onFormCategoryTypeChange(categoryType.selected.value);
  }

  onChangeQuestions(questions) {
    let allQuestionsValid = true;

    if (questions && questions.length > 0) {
      let flattenedQuestions = questions.flat();
      flattenedQuestions.forEach((question) => {
        if (question.validationState && !question.validationState.valid) {
          allQuestionsValid = false;
        }
      });
    }

    this.setState({ questions });
    let configurationModel = JsonConverter.convertCitrusToSurveyjsJsonConfiguration(questions);
    let configuration = JSON.stringify(configurationModel);

    this.props.onFormQuestionsValidChanged(allQuestionsValid);
    this.props.onConfigurationModified(configuration);
  };

  onResponse(id, response) {
    const index = this.state.responses.findIndex(x => x.id === id);

    if (index < 0) {
      this.setState({ responses: [...this.state.responses, response] });
    }
    else {
      this.setState({ responses: replaceAt(this.state.responses, index, response) });
    }
  }

  onComment(id, comment) {
    const index = this.state.responses.findIndex(x => x.id === id);

    if (index < 0) {
      this.setState({ responses: [...this.state.responses, comment] });
    } else {
      this.setState({ responses: replaceAt(this.state.responses, index, comment) });
    }
  }

  onComment(id, comment) {
    const index = this.state.responses.findIndex(x => x.id === id);

    if (index < 0) {
      this.setState({ responses: [...this.state.responses, comment] });
    } else {
      this.setState({ responses: replaceAt(this.state.responses, index, comment) });
    }
  }

  render() {
    const flattenedQuestions = this.state.questions ? this.state.questions.flat() : [];
    return (
      <React.Fragment>
      {!this.props.editRestricted ?
        <Tabs activeIndex={this.state.activeTab} onChange={this.onChangeTab} className="editor-tabs-container">
          <Tab text="Design">
            <div className="citrus-question-builder">
              <PctyQuestionBuilder
                id="citrus-question-builder"
                builderType={BUILDER_TYPE.survey}
                builderTypeName={this.props.formLabel}
                questions={flattenedQuestions}
                name={this.state.name}
                onChangeName={this.onChangeName}
                configOptions={this.qbConfigOptions}
                onChangeQuestions={this.onChangeQuestions}
                onChangeCategoryType={this.onChangeCategoryType}
                onDrop={() => {}}
                categoryType={this.state.categoryType}
                categoryTypeOptions={this.state.formTypeOptions}
                categoryTypeRequired={this.props.categoryRequired}
                premiumVideoEnabled={this.props.premiumVideoEnabled}
                onGetViewVideoToken={(videoId) => this.props.onGetViewVideoToken(videoId)}
                onGetSingleManageVideoToken={(videoId) => this.props.onGetSingleManageVideoToken(videoId)}
                onVideoDoneHandler={(videoEvent) => this.props.onVideoDoneHandler(videoEvent)}
                videoStudioEnabled={this.props.videoStudioEnabled}
                questionCommentsEnabled={this.props.questionCommentsEnabled}
                questionBanksEnabled={this.props.questionBanksEnabled}
                questionBankQuestions={this.props.questionBankQuestions}
                />
            </div>
          </Tab>
          <Tab text="Preview">
            <div className="citrus-question-previewer pcty-border-top">
              <PctySurvey
                key="preview-question-key"
                id="citrus-question-previewer"
                name={this.state.name.value}
                questions={flattenedQuestions}
                settings={this.state.surveySettings}
                previewOnly={false}
                responses={this.state.responses}
                onResponse={this.onResponse}
                onComment={this.onComment}
                onComplete={() => {}}
                onGetViewVideoToken={(videoId) => this.props.onGetViewVideoToken(videoId)}
                />
            </div>
          </Tab>
        </Tabs>
      :
        <div className="citrus-question-previewer">
          <PctySurvey
            key="preview-question-key"
            id="citrus-question-previewer"
            name={this.state.name.value}
            questions={flattenedQuestions}
            settings={this.state.surveySettings}
            previewOnly={false}
            responses={this.state.responses}
            onResponse={this.onResponse}
            onComment={this.onComment}
            onComplete={() => {}}
            onGetViewVideoToken={(videoId) => this.props.onGetViewVideoToken(videoId)}
            />
        </div>
      }
      </React.Fragment>
    );
  }

}

CitrusFormEditor.propTypes = {
  editRestricted: PropTypes.bool,
  formName: PropTypes.string,
  formLabel: PropTypes.string,
  configuration: PropTypes.string,
  showCategories: PropTypes.bool,
  formCategories: PropTypes.arrayOf(PropTypes.any),
  selectedFormCategoryId: PropTypes.string,
  categoryRequired: PropTypes.bool,
  premiumVideoEnabled: PropTypes.bool,
  onGetViewVideoToken: PropTypes.func,
  onVideoDoneHandler: PropTypes.func,
  onConfigurationModified: PropTypes.func.isRequired,
  onNameChange: PropTypes.func.isRequired,
  onFormCategoryTypeChange: PropTypes.func.isRequired,
  onFormQuestionsValidChanged: PropTypes.func.isRequired,
  videoStudioEnabled: PropTypes.bool,
  questionCommentsEnabled: PropTypes.bool,
  questionBanksEnabled: PropTypes.bool,
  questionBankQuestions: PropTypes.arrayOf(PropTypes.any),
};

CitrusFormEditor.defaultProps = {
  editRestricted: false,
  formName: '',
  formLabel: 'form',
  configuration: null,
  showCategories: false,
  categoryRequired: false,
  premiumVideoEnabled: false,
  formCategories: [],
  selectedFormCategoryId: '',
  questionCommentsEnabled: false,
  questionBanksEnabled: false,
  questionBankQuestions: [],
};

export default CitrusFormEditor
